/* just cold brew — hero trailer viewer
   1. video plays once on load (if present)
   2. when video ends, swap to 360° canvas at frame 1 (matches video's last frame)
   3. user can drag to spin
   4. on mobile or reduced-motion, skip video, go straight to 360°
*/
(function () {
  'use strict';

  function init() {
    var container = document.querySelector('[data-jcb-trailer]');
    if (!container) return;

    var video = container.querySelector('[data-jcb-trailer-video]');
    var still = container.querySelector('[data-jcb-trailer-still]');
    var canvas = container.querySelector('[data-jcb-trailer-360]');

    var frameCount = parseInt(container.getAttribute('data-frames-360') || '0', 10);
    var prefix = container.getAttribute('data-frames-prefix') || 'trailer-';
    var suffix = container.getAttribute('data-frames-suffix') || '.png';
    var assetsBase = guessAssetsBase();

    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var skipVideo = isMobile || reducedMotion || !video;

    if (frameCount > 0 && canvas) {
      preloadFrames(frameCount, prefix, suffix, assetsBase, function (frames) {
        if (skipVideo) {
          showCanvas(canvas, still, video, frames);
        } else {
          handoffOnVideoEnd(video, canvas, still, frames);
        }
      });
    } else if (skipVideo && video) {
      video.style.display = 'none';
    }
  }

  function guessAssetsBase() {
    // find a known asset link to derive the /assets/ URL base
    var links = document.querySelectorAll('link[href*="/assets/"], script[src*="/assets/"]');
    for (var i = 0; i < links.length; i++) {
      var url = links[i].href || links[i].src;
      var match = url && url.match(/^(.*\/assets\/)/);
      if (match) return match[1];
    }
    return '/assets/';
  }

  function pad(n) {
    return n < 10 ? '00' + n : n < 100 ? '0' + n : '' + n;
  }

  function preloadFrames(count, prefix, suffix, base, callback) {
    var frames = new Array(count);
    var loaded = 0;
    var errored = 0;
    for (var i = 1; i <= count; i++) {
      (function (idx) {
        var img = new Image();
        img.onload = function () {
          frames[idx - 1] = img;
          loaded++;
          if (loaded + errored === count) callback(frames.filter(Boolean));
        };
        img.onerror = function () {
          errored++;
          if (loaded + errored === count) callback(frames.filter(Boolean));
        };
        img.src = base + prefix + pad(idx) + suffix;
      })(i);
    }
  }

  function handoffOnVideoEnd(video, canvas, still, frames) {
    if (!video) return;
    var ended = false;
    function done() {
      if (ended) return;
      ended = true;
      showCanvas(canvas, still, video, frames);
    }
    video.addEventListener('ended', done);
    // safety: if video can't play (autoplay blocked), still show the 360°
    var fallback = setTimeout(function () {
      if (video.readyState < 2 || video.paused) done();
    }, 5000);
    video.addEventListener('playing', function () { clearTimeout(fallback); });
  }

  function showCanvas(canvas, still, video, frames) {
    if (!frames || !frames.length || !canvas) {
      // no frames — leave the still image showing
      if (still) still.hidden = false;
      if (video) video.style.display = 'none';
      return;
    }
    var ctx = canvas.getContext('2d');
    var first = frames[0];
    canvas.width = first.naturalWidth;
    canvas.height = first.naturalHeight;
    canvas.hidden = false;
    if (still) still.hidden = true;
    if (video) video.style.display = 'none';

    var currentFrame = 0;
    function draw(idx) {
      var f = frames[idx];
      if (!f) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(f, 0, 0, canvas.width, canvas.height);
      currentFrame = idx;
    }
    draw(0);

    // drag-to-spin
    var dragging = false;
    var startX = 0;
    var startFrame = 0;
    var sensitivity = 8; // pixels per frame

    function onDown(e) {
      dragging = true;
      startX = getX(e);
      startFrame = currentFrame;
      e.preventDefault();
    }
    function onMove(e) {
      if (!dragging) return;
      var dx = getX(e) - startX;
      var delta = Math.round(dx / sensitivity);
      var next = ((startFrame - delta) % frames.length + frames.length) % frames.length;
      if (next !== currentFrame) draw(next);
    }
    function onUp() {
      dragging = false;
    }
    function getX(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientX;
      return e.clientX;
    }

    canvas.addEventListener('mousedown', onDown);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
    canvas.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: false });
    window.addEventListener('touchend', onUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
